// config.js
const apiUrl = 'https://flipkart-2-onub.onrender.com'; // Replace with your actual API base URL
export default apiUrl;
   
